var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-page-container"},[(_vm.pageId)?_c('PageParser',{attrs:{"pageUUID":_vm.pageId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }